import { saveAs } from 'file-saver';

// ---------------------------------------------------------------------------
// A DOWNLOAD THAT IS ACTUALLY A DOWNLOAD. A link to a stored file obeys the
// content type S3 answers with — a .docx is saved, a PDF opens in the tab —
// and `<a download>` is ignored cross-origin, so a "Download" link either
// saved the file or replaced the page with it. Pulling the bytes and handing
// them over under the file's own name makes the verb do the one thing it
// says (the pattern ExpenseDetails wrote on 28/09/2026). The vault and CV
// buckets answer a cross-origin read with `*` (checked 14/10/2026).
// ---------------------------------------------------------------------------

/** The last part of a stored address, decoded: the name a save falls back on. */
const nameOf = (url) => {
  const last = String(url).split('?')[0].split('/').pop();
  try {
    return decodeURIComponent(last);
  } catch (error) {
    return last;
  }
};

/**
 * Saves the file at `url` as `name`. Resolves 'saved' once the browser has
 * the file, or 'opened' when the read was refused (CORS, the network) and the
 * file was opened in a new tab instead — the link may still work where the
 * read did not. Rejects when the bucket answers with an error: the file is
 * not there, and a tab would only show S3's XML.
 */
export async function downloadFile(url, name, deps = {}) {
  const {
    fetchFile = (target) => window.fetch(target),
    save = saveAs,
    openTab = (target) => window.open(target, '_blank', 'noopener,noreferrer')
  } = deps;
  if (!url) throw new Error('This file has no address.');
  let answer;
  try {
    answer = await fetchFile(url);
  } catch (error) {
    openTab(url);
    return 'opened';
  }
  if (!answer.ok) {
    throw new Error(`The file could not be fetched (${answer.status}).`);
  }
  save(await answer.blob(), name || nameOf(url));
  return 'saved';
}
